import { FC } from 'react'
import { Icon } from '@chakra-ui/react'

export const Url: FC = () => {
  return (
    <Icon
      width="70px"
      height="70px"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path stroke="#fff" strokeWidth={4} d="M58.625 29.067 38.341 49.35" />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={4}
        d="M67.64 7.657H2.281V64H67.64V7.657ZM2.281 20.052H67.64"
      />
      <path stroke="#fff" strokeWidth={4} d="M40.59 29.067h18.03v18.03" />
      <path
        fill="#fff"
        d="M8.48 15.544a1.69 1.69 0 1 0 0-3.38 1.69 1.69 0 0 0 0 3.38ZM15.24 15.544a1.69 1.69 0 1 0 0-3.38 1.69 1.69 0 0 0 0 3.38Z"
      />
    </Icon>
  )
}
